/* Car-med Lifetime Wipers theme script: fit finder + warranty claim form. Guarded so it runs once. */
(function () {
  if (window.LW) return; window.LW = true;
  const money = (n, sym) => (sym || '$') + Number(n).toFixed(2);
  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  async function cartAdd(items) {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || e.message || 'Could not add to cart'); }
    return r.json();
  }

  /* ---------- Fit finder ---------- */
  document.querySelectorAll('[data-lw-finder]').forEach(async root => {
    const makeSel = root.querySelector('[data-make]'), modelSel = root.querySelector('[data-model]'), yearSel = root.querySelector('[data-year]');
    const result = root.querySelector('[data-result]'), lineSel = root.querySelector('[data-line]');
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent || '{}');
    const sym = root.dataset.currency || '$';
    let FIT = [];
    try { FIT = await (await fetch(root.dataset.fitment)).json(); } catch (e) { FIT = []; }
    const fill = (sel, ph, items) => { sel.innerHTML = ''; sel.add(new Option(ph, '')); items.forEach(i => sel.add(new Option(i, i))); };
    fill(makeSel, 'Choose make', [...new Set(FIT.map(f => f.make))].sort());
    makeSel.addEventListener('change', () => {
      fill(modelSel, 'Choose model', [...new Set(FIT.filter(f => f.make === makeSel.value).map(f => f.model))].sort());
      modelSel.disabled = !makeSel.value; fill(yearSel, 'Choose year', []); yearSel.disabled = true;
    });
    modelSel.addEventListener('change', () => {
      const ys = new Set(); FIT.filter(f => f.make === makeSel.value && f.model === modelSel.value).forEach(f => { for (let y = f.to; y >= f.from; y--) ys.add(y); });
      fill(yearSel, 'Choose year', [...ys].sort((a, b) => b - a)); yearSel.disabled = !modelSel.value;
    });
    Object.entries(variants).forEach(([h, p]) => { if (!p.rear) lineSel.add(new Option(`${p.title} · ${money(p.price / 100, sym)}/blade`, h)); });
    let cur = null;
    const note = root.querySelector('[data-note]');
    const updNote = () => { const p = variants[lineSel.value]; if (cur && p) note.textContent = `Both front blades in ${p.title}: ${money(2 * p.price / 100, sym)}. Lifetime warranty included.`; };
    lineSel.addEventListener('change', updNote);
    const manual = root.querySelector('[data-manual]'), toggle = root.querySelector('[data-manual-toggle]');
    const mD = root.querySelector('[data-md]'), mP = root.querySelector('[data-mp]'), mR = root.querySelector('[data-mr]');
    for (let i = 14; i <= 28; i++) { mD.add(new Option(i + '"', i)); mP.add(new Option(i + '"', i)); }
    for (let i = 10; i <= 16; i++) mR.add(new Option(i + '"', i));
    mD.value = 26; mP.value = 18;
    const showManual = () => { manual.hidden = false; toggle.textContent = 'Hide manual entry'; mD.focus(); };
    toggle.addEventListener('click', e => { e.preventDefault(); if (manual.hidden) showManual(); else { manual.hidden = true; toggle.textContent = "My car isn't listed, I'll enter the lengths"; } });
    function show(title) {
      root.querySelector('[data-title]').textContent = title;
      const tiles = [['Driver side', cur.driver], ['Passenger side', cur.passenger]]; if (cur.rear) tiles.push(['Rear', cur.rear]);
      root.querySelector('[data-grid]').innerHTML = tiles.map(([k, v]) => `<div class="lw-fit-tile"><div class="k">${k}</div><div class="v">${v}"<small>${Math.round(v * 25.4)} mm</small></div></div>`).join('');
      root.querySelector('[data-add-rear]').hidden = !cur.rear;
      updNote(); result.hidden = false;
    }
    root.querySelector('form:not([data-manual])').addEventListener('submit', e => {
      e.preventDefault();
      const y = +yearSel.value;
      const hit = FIT.find(f => f.make === makeSel.value && f.model === modelSel.value && y >= f.from && y <= f.to);
      if (!hit) { result.hidden = true; showManual(); return; }
      cur = hit; show(`${y} ${cur.make} ${cur.model} · ${cur.connector} arm`);
    });
    manual.addEventListener('submit', e => {
      e.preventDefault();
      cur = { driver: +mD.value, passenger: +mP.value, rear: mR.value ? +mR.value : null, connector: 'J-hook' };
      show('Your vehicle · J-hook arm');
    });
    async function addPair(handle, sizes) {
      const p = variants[handle]; if (!p) return;
      const items = sizes.map(s => ({ id: p.variants[String(s)], quantity: 1 })).filter(i => i.id);
      if (items.length < sizes.length) { alert(`We don't stock every length for ${p.title} in this size. Choose another line.`); return; }
      try { await cartAdd(items); location.href = '/cart'; } catch (err) { alert(err.message); }
    }
    root.querySelector('[data-add-pair]').addEventListener('click', () => cur && addPair(lineSel.value, [cur.driver, cur.passenger]));
    root.querySelector('[data-add-rear]').addEventListener('click', () => { const rear = Object.keys(variants).find(h => variants[h].rear); if (cur && cur.rear && rear) addPair(rear, [cur.rear]); });
  });

  /* ---------- Warranty claim form ---------- */
  document.querySelectorAll('[data-lw-claim]').forEach(form => {
    const msg = form.querySelector('[data-msg]'), btn = form.querySelector('[type=submit]');
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const blades = [...form.querySelectorAll('input[name=blade]:checked')].map(i => i.value);
      if (!blades.length) { msg.hidden = false; msg.className = 'lw-msg err'; msg.textContent = 'Pick at least one blade.'; return; }
      const f = id => (form.querySelector('#' + id) || {}).value || '';
      const properties = {
        'Original order': f('cOrder').trim(), 'Email on order': f('cEmail').trim().toLowerCase(),
        'Vehicle': `${f('cYear')} ${f('cMake').trim()} ${f('cModel').trim()}`,
        'Blades': blades.join(' + '), 'Problem': (form.querySelector('input[name=reason]:checked') || {}).value || '',
        'Notes': f('cNotes').trim(), 'Return of worn blades': `Agreed, within ${form.dataset.returnDays} days`
      };
      Object.keys(properties).forEach(k => { if (!properties[k]) delete properties[k]; });
      btn.disabled = true; const t = btn.textContent; btn.textContent = 'Preparing checkout…';
      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        await cartAdd([{ id: Number(form.dataset.variant), quantity: 1, properties }]);
        location.href = '/checkout';
      } catch (err) {
        msg.hidden = false; msg.className = 'lw-msg err'; msg.textContent = err.message + '. Email ' + form.dataset.support + ' and we will handle the claim by hand.';
        btn.disabled = false; btn.textContent = t;
      }
    });
  });
})();
